import { useTranslation } from 'react-i18next'

import { Alert, RadioButtonOptionCard } from '@reveni-io/reveni-ui'

import { feeTypes } from '../constants'
import SectionHeader from '../SectionHeader/SectionHeader'
import * as SharedStyles from '../styles'
import FeeConfiguration from './FeeConfiguration/FeeConfiguration'
import RequestMultipleLabelsConfiguration from './RequestMultipleLabelsConfiguration/RequestMultipleLabelsConfiguration'
import { feeTypeCards, feeTypeInputName } from './constants'
import * as Styles from './styles'

const CostSection = ({ config, currencies, defaultStoreCurrency, onChange, disabled, deliveryMethodType }) => {
  const { t } = useTranslation()

  const selectedFeeType = config?.extra_fee_type || feeTypes.flatFee

  const handleChangeFeeType = value => onChange({ extra_fee_type: value })

  return (
    <Styles.Container>
      <SectionHeader title={t('Coste')} />
      <SharedStyles.CardsGrid columns={2}>
        {feeTypeCards.map(card => {
          return (
            <RadioButtonOptionCard
              key={card.value}
              icon={<card.Icon size={24} weight="thin" />}
              title={t(card.title)}
              description={t(card.description)}
              name={feeTypeInputName}
              value={card.value}
              selected={selectedFeeType === card.value}
              disabled={disabled}
              onChange={handleChangeFeeType}
            />
          )
        })}
      </SharedStyles.CardsGrid>
      <Alert type="info">{t('Este precio se convertirá automáticamente a la divisa del pedido del cliente.')}</Alert>
      <FeeConfiguration
        config={config}
        currencies={currencies}
        defaultStoreCurrency={defaultStoreCurrency}
        onChange={onChange}
        disabled={disabled}
      />
      <RequestMultipleLabelsConfiguration
        isCarrierConnected={config?.carrier_service?.is_connected}
        onChange={onChange}
        config={config}
        deliveryMethodType={deliveryMethodType}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default CostSection
